//
// Menu
// --------------------------------------------------

$('#nav1').on('click', function() {
    'use strict';

    var $this = $(this);

    if ($this.hasClass('open')) {
        $this.removeClass('open');
        $('.nav1').hide();
        $('.full-width-nav').hide();

    } else {

        $('.full-width-nav').show();

        $this.addClass('open');
        $('.nav1').show();

        $('#nav2').removeClass('open');
        $('.nav2').hide();

        $('#nav3').removeClass('open');
        $('.nav3').hide();

        $('#nav4').removeClass('open');
        $('.nav4').hide();

        $('#nav5').removeClass('open');
        $('.nav5').hide();

    }

});

$('#nav2').on('click', function() {
    'use strict';

    var $this = $(this);

    if ($this.hasClass('open')) {

        $this.removeClass('open');
        $('.nav2').hide();
        $('.full-width-nav').hide();

    } else {

        $('.full-width-nav').show();

        $('#nav1').removeClass('open');
        $('.nav1').hide();

        $this.addClass('open');
        $('.nav2').show();

        $('#nav3').removeClass('open');
        $('.nav3').hide();

        $('#nav4').removeClass('open');
        $('.nav4').hide();

        $('#nav5').removeClass('open');
        $('.nav5').hide();

    }

});

$('#nav3').on('click', function() {
    'use strict';

    var $this = $(this);

    if ($this.hasClass('open')) {

        $this.removeClass('open');
        $('.nav3').hide();
        $('.full-width-nav').hide();

    } else {

        $('.full-width-nav').show();

        $('#nav1').removeClass('open');
        $('.nav1').hide();

        $('#nav2').removeClass('open');
        $('.nav2').hide();

        $this.addClass('open');
        $('.nav3').show();

        $('#nav4').removeClass('open');
        $('.nav4').hide();

        $('#nav5').removeClass('open');
        $('.nav5').hide();

    }

});

$('#nav4').on('click', function() {
    'use strict';

    var $this = $(this);

    if ($this.hasClass('open')) {

        $this.removeClass('open');
        $('.nav4').hide();
        $('.full-width-nav').hide();

    } else {

        $('.full-width-nav').show();

        $('#nav1').removeClass('open');
        $('.nav1').hide();

        $('#nav2').removeClass('open');
        $('.nav2').hide();

        $('#nav3').removeClass('open');
        $('.nav3').hide();

        $this.addClass('open');
        $('.nav4').show();

        $('#nav5').removeClass('open');
        $('.nav5').hide();

    }

});

$('#nav5').on('click', function() {
    'use strict';

    var $this = $(this);

    if ($this.hasClass('open')) {

        $this.removeClass('open');
        $('.nav5').hide();
        $('.full-width-nav').hide();

    } else {

        $('.full-width-nav').show();

        $('#nav1').removeClass('open');
        $('.nav1').hide();

        $('#nav2').removeClass('open');
        $('.nav2').hide();

        $('#nav3').removeClass('open');
        $('.nav3').hide();

        $('#nav4').removeClass('open');
        $('.nav4').hide();

        $this.addClass('open');
        $('.nav5').show();

    }

});

$('.navigation-flyout-close').on('click', function() {
    $('.full-width-nav').hide();

    $('#nav1').removeClass('open');
    $('.nav1').hide();

    $('#nav2').removeClass('open');
    $('.nav2').hide();

    $('#nav3').removeClass('open');
    $('.nav3').hide();

    $('#nav4').removeClass('open');
    $('.nav4').hide();

    $('#nav5').removeClass('open');
    $('.nav5').hide();
});

$('.navbar-toggle').on('click', function() {
    'use strict';

    if ($( '.navbar-collapse' ).hasClass('in')) {
        $( '#mobile-navbar-state' ).removeClass( 'fa-times' );
        $( '#mobile-navbar-state' ).addClass( 'fa-bars' );
    } else {
        $( '#mobile-navbar-state' ).removeClass( 'fa-bars' );
        $( '#mobile-navbar-state' ).addClass( 'fa-times' );
    }

});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/Menu.js